import { MotionStyle, m } from "framer-motion";
import { alpha, styled } from "@mui/material/styles";
import { Box, SxProps } from "@mui/material";
import { ReactElement } from "react";
import ProgressBar from "../ProgressBar";

// ----------------------------------------------------------------------

const RootStyle = styled("div")(() => ({
  right: 0,
  bottom: 0,
  zIndex: 99999,
  width: "100%",
  height: "100%",
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
}));

// ----------------------------------------------------------------------

type Props = {
  isDashboard?: boolean;
  sx?: SxProps;
  text?: string | ReactElement;
  textStyle?: MotionStyle;
  animationColor?: string;
};

export default function LoadingScreen({
  isDashboard,
  text,
  textStyle,
  animationColor,
  ...other
}: Props) {
  return (
    <>
      <ProgressBar />

      {!isDashboard && (
        <RootStyle {...other}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <m.div
              animate={{
                scale: [1, 0.9, 0.9, 1, 1],
                opacity: [1, 0.48, 0.48, 1, 1],
              }}
              transition={{
                duration: 2,
                ease: "easeInOut",
                repeatDelay: 1,
                repeat: Infinity,
              }}
            >
              {/* <LogoIcon disabledLink sx={{ width: 64, height: 64 }} /> */}
            </m.div>

            <Box
              component={m.div}
              animate={{
                scale: [1.2, 1, 1, 1.2, 1.2],
                rotate: [270, 0, 0, 270, 270],
                opacity: [0.25, 1, 1, 1, 0.25],
                borderRadius: ["45%", "45%", "50%", "50%", "45%"],
              }}
              transition={{ ease: "linear", duration: 3.2, repeat: Infinity }}
              sx={{
                width: 100,
                height: 100,
                borderRadius: "45%",
                position: "absolute",
                border: (theme) =>
                  `solid 3px ${alpha(animationColor || theme.palette.primary.dark, 0.24)}`,
              }}
            />

            <Box
              component={m.div}
              animate={{
                scale: [1, 1.2, 1.2, 1, 1],
                rotate: [0, 270, 270, 0, 0],
                opacity: [1, 0.25, 0.25, 0.25, 1],
                borderRadius: ["45%", "45%", "50%", "50%", "45%"],
              }}
              transition={{
                ease: "linear",
                duration: 3.2,
                repeat: Infinity,
              }}
              sx={{
                width: 120,
                height: 120,
                borderRadius: "25%",
                position: "absolute",
                border: (theme) =>
                  `solid 8px ${alpha(animationColor || theme.palette.primary.dark, 0.24)}`,
              }}
            />
          </Box>
          {text && (
            <m.div
              animate={{
                opacity: [1, 0.5, 1, 0.0, 1],
              }}
              transition={{ ease: "linear", duration: 3.2, repeat: Infinity }}
              style={textStyle && { ...textStyle }}
            >
              {text}
            </m.div>
          )}
        </RootStyle>
      )}
    </>
  );
}
